"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regionAttributeModel = exports.regionAttributeHeadersSchema = exports.regionModel = void 0;

var _types = require("../../../types");

var regionModel = {
  // Attributes
  name: {
    type: String,
    path: '$.Name'
  },
  id: {
    type: Number,
    path: '$.Id'
  },
  type: {
    type: Number,
    path: '$.Type'
  },
  zoom: {
    type: Number,
    path: '$.Zoom'
  },
  isSelected: {
    type: _types.BooleanAsNumber,
    path: '$.Selected'
  },
  imageFocus: {
    type: Number,
    path: '$.ImageFocus'
  },
  length: {
    type: Number,
    path: '$.Length'
  },
  area: {
    type: Number,
    path: '$.Area'
  },
  lengthMicrons: {
    type: Number,
    path: '$.LengthMicrons'
  },
  areaMicrons: {
    type: Number,
    path: '$.AreaMicrons'
  },
  negativeRoa: {
    type: Number,
    path: '$.NegativeROA'
  },
  inputRegionId: {
    type: Number,
    path: '$.InputRegionId'
  },
  canAnalyze: {
    type: _types.BooleanAsNumber,
    path: '$.Analyze'
  },
  displayId: {
    type: Number,
    path: '$.DisplayId'
  },
  note: {
    type: String,
    path: '$.Text'
  },
  globalId: {
    type: String,
    path: '$.GlobalId'
  },
  imageLocation: {
    type: String,
    path: '$.ImageLocation'
  },
  markupImageId: {
    type: Number,
    path: '$.MarkupImageId'
  },
  // Children
  vertices: {
    path: 'Vertices[0].Vertex',
    model: {
      x: {
        type: Number,
        path: '$.X'
      },
      y: {
        type: Number,
        path: '$.Y'
      },
      z: {
        type: Number,
        path: '$.Z'
      }
    } // "attributes" is derived in "createRegion"

  }
};
exports.regionModel = regionModel;
var regionAttributeHeadersSchema = {
  path: 'Regions[0].RegionAttributeHeaders[0].AttributeHeader',
  key: 'id',
  model: {
    // Attributes
    id: {
      type: Number,
      path: '$.Id'
    },
    name: {
      type: String,
      path: '$.Name'
    },
    value: {
      type: String,
      path: '$.Value'
    },
    // Children
    globalId: {
      type: String,
      path: 'GlobalId'
    }
  }
};
exports.regionAttributeHeadersSchema = regionAttributeHeadersSchema;
var regionAttributeModel = {
  // Attributes
  id: {
    type: Number,
    path: '$.Id'
  },
  name: {
    type: String,
    path: '$.Name'
  },
  value: {
    type: String,
    path: '$.Value'
  },
  // Children (probably not needed for regions but including for completeness)
  globalId: {
    type: String,
    path: 'globalId'
  },
  headerGlobalId: {
    type: String,
    path: 'HeaderGlobalId'
  }
};
exports.regionAttributeModel = regionAttributeModel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/annotations/response-parsers/region-models.js
// module id = 235
// module chunks = 0